import React from 'react';

interface IProps {
    /** Class or id of field you wish to append to. Pass in as ".element" or "#element" */
    field: string;
    /** Pass a custom clear Value when clicked.  */
    customClearValue?: any;
}

const FormControlClear: React.FC<IProps> = (props: IProps) => {
    const { field, customClearValue } = props;

    const handleClear = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        let input: any = document?.querySelector(field);
        if(input){
            let resetValue: any = customClearValue === undefined ? "" : customClearValue;
            // @ts-ignore
            let nativeInputValueSetter: any = Object.getOwnPropertyDescriptor(
                window.HTMLInputElement.prototype, 
                "value"
            ).set;
            nativeInputValueSetter.call(input, resetValue);
            let inputEvent = new Event('input', { bubbles: true});
            input.dispatchEvent(inputEvent);
        }
    }

    return <span onClick={handleClear} data-clear-input>&times;</span>
}

FormControlClear.defaultProps = {
    customClearValue: undefined
}

export default FormControlClear;